<template>
  <div>
    <v-toolbar class="primary elevation-0 small-extension imoveis-toolbar" dark>
      <h1 class="titulo titulo-imoveis">Imóveis</h1>
      <div class="opcoes_lista_mapa opcoes_lista_mapa_mobile">
        <router-link :to="{ name: 'ImoveisLista' }">
          <v-btn flat :ripple="false" class="opcao-view-btn">
            <v-icon class="mr-1">list</v-icon> Lista
          </v-btn>
        </router-link>
        <router-link :to="{ name: 'ImoveisMapa' }">
          <v-btn flat :ripple="false" class="opcao-view-btn">
            <v-icon class="mr-1">room</v-icon> Mapa
          </v-btn>
        </router-link>
      </div>
    </v-toolbar>
    <v-tabs centered dark @input="changeTab">
      <v-tabs-bar slot="activators">
        <v-tabs-slider class="secondary"></v-tabs-slider>
        <v-tabs-item v-for="(tab, i) in tabs" :key="i" :href="'#' + tab.id">{{ tab.title }}</v-tabs-item>
      </v-tabs-bar>
      <v-tabs-content lazy v-for="(tab, i) in tabs" :key="i" :id="tab.id">
        <div v-if="Object.keys(filtros).length > 0" class="pt-2">
          <v-subheader style="margin: 0; margin-top: 9px;" class="text-xs-left">
            <template v-if="!filtros.hasOwnProperty('locado_indice')">
              <template v-if="paginacao.total === 0">
                Nenhum resultado encontrado
              </template>
              <template v-else-if="paginacao.total === 1">
                1 resultado
              </template>
              <template v-else>
                {{ paginacao.total }} resultados
              </template>
            </template>
            <template v-else>
              {{ imoveis.length }} resultado(s)
            </template>
          </v-subheader>
        </div>
        <div v-else-if="Object.keys(filtros).length === 0 && paginacao.total > 0" class="text-xs-center grey--text text--darken-1 pt-2 mt-3">
          <template v-if="paginacao.total === 1">
            1 imóvel
          </template>
          <template v-else>
            {{ String(paginacao.total).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.') }} imóveis
          </template>
        </div>
        <template v-if="tab.id === tabAtiva">
          <ListaImovel v-for="(item, index) in imoveis" :flat="index === 0" :key="index" :imovel="item" :exibirStatus="true"></ListaImovel>
        </template>
      </v-tabs-content>
    </v-tabs>
    <v-speed-dial fab fixed bottom right v-model="fabSave" v-if="imoveis.length > 0 && $auth.check(['Administrador', 'Patrimônio'])">
      <v-btn dark fab slot="activator" class="primary" v-model="fabSave">
        <v-icon>save</v-icon>
        <v-icon>close</v-icon>
      </v-btn>
      <v-btn fab dark small class="grey" v-tooltip:left="{ html: 'PDF' }" @click.native="downloadLista('pdf')">
        <v-icon>mdi-file-pdf</v-icon>
      </v-btn>
      <v-btn fab dark small class="grey" v-tooltip:left="{ html: 'Excel' }" @click.native="downloadLista('excel')">
        <v-icon>mdi-file-excel</v-icon>
      </v-btn>
    </v-speed-dial>
    
    <div class="secondary--text text-xs-center subheading my-5" v-if="paginacao !== undefined && paginacao.current_page < paginacao.total_pages">
      <span @click="loadImoveis(paginacao.current_page + 1)" style="cursor: pointer;">CARREGAR MAIS</span>
    </div>
    <div v-if="paginacao.total === 0 && !filtros.hasOwnProperty('locado_indice')" class="subheading text-xs-center pt-5 pb-5 px-4">Sua busca não gerou nenhum resultado, tente uma nova busca.</div>
    <div v-else-if="imoveis.length === 0 && filtros.hasOwnProperty('locado_indice')" class="subheading text-xs-center pt-5 pb-5 px-4">Sua busca não gerou nenhum resultado, tente uma nova busca.</div>
  </div>
</template>

<script>
  import ListaImovel from './Lista/ListaImovel'
  import _ from 'lodash'
  import * as jsPDF from 'jspdf'
  import 'jspdf-autotable'
  import * as XlsxPopulate from 'xlsx-populate/browser/xlsx-populate'
  import moment from 'moment'
  import currencyFormatter from 'currency-formatter'

  export default {
    components: {
      ListaImovel
    },
    computed: {
      imoveis () {
        return this.$store.getters['imoveis/lista']
      },
      paginacao () {
        return this.$store.getters['imoveis/listaPaginacao']
      },
      filtros () {
        return this.$store.getters['imoveis/filtros']
      },
      imoveisDownload () {
        return this.$store.getters['imoveis/listaDownload']
      },
      coords () {
        return this.$store.getters['utils/coords']
      },
      tabs () {
        let tabs = []
        if (this.isMobile) {
          tabs.push({ title: 'Distância', id: 'distancia' })
        }
        if (this.$hasGranularPermission('vistoria', 'view')) {
          tabs.push({ title: 'Vistoria', id: 'vistoria' })
        }
        if (this.$hasGranularPermission('tarefas', 'view')) {
          tabs.push({ title: 'Tarefas', id: 'tarefas' })
        }
        if (tabs.length === 0) {
          tabs.push({ title: 'Lista', id: 'geral' })
        }
        return tabs
      }
    },
    data () {
      return {
        unsubscribe: null,
        tabAtiva: '',
        fabSave: false,
        isMobile: false
      }
    },
    mounted () {
      this.updateViewport()
      window.addEventListener('resize', this.updateViewport)

      if (this.tabs.length > 0) {
        this.tabAtiva = this.tabs[0].id
      }
      this.clearImoveis()
      this.loadImoveis()

      this.unsubscribe = this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'imoveis/SET_FILTROS') {
          this.clearImoveis()
          this.loadImoveis()
        }
      })
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.updateViewport)
      this.unsubscribe()
    },
    methods: {
      updateViewport () {
        const isMobile = window.innerWidth < 960
        if (isMobile === this.isMobile) {
          return
        }

        this.isMobile = isMobile

        if (this.tabs.length < 1) {
          return
        }

        const firstTabId = this.tabs[0].id
        const hasCurrentTab = _.some(this.tabs, { id: this.tabAtiva })

        if (!hasCurrentTab || (this.isMobile && this.tabAtiva !== firstTabId)) {
          const hadActiveTab = !!this.tabAtiva
          this.tabAtiva = firstTabId
          if (hadActiveTab) {
            this.clearImoveis()
            this.loadImoveis()
          }
        }
      },
      normalizeTabId (tabId) {
        if (typeof tabId !== 'string') {
          return tabId
        }

        return tabId.charAt(0) === '#' ? tabId.slice(1) : tabId
      },
      setTabPayloadParams (payload) {
        if (this.tabAtiva === 'distancia') {
          payload.parametro = 'distancia'
          payload.latitude = this.coords.latitude
          payload.longitude = this.coords.longitude
          return
        }

        payload.parametro = this.tabAtiva
      },
      downloadLista (tipo) {
        /* eslint-disable */
        this.$store.dispatch('utils/showLoading')

        let filtrosFormatados = {}
        if (Object.keys(this.filtros).length > 0) {
          if (this.filtros.hasOwnProperty('proprietario')) {
            filtrosFormatados['Proprietário'] = _.filter(this.filtros.proprietario).join(', ')
          }
          if (this.filtros.hasOwnProperty('tipo')) {
            filtrosFormatados['Tipo'] = _.filter(this.filtros.tipo).join(', ')
          }
          if (this.filtros.hasOwnProperty('uf')) {
            filtrosFormatados['Estado'] = _.filter(this.filtros.uf).join(', ')
          }
          if (this.filtros.hasOwnProperty('cidade')) {
            filtrosFormatados['Cidade'] = _.filter(this.filtros.cidade).join(', ')
          }
          if (this.filtros.hasOwnProperty('bairro')) {
            filtrosFormatados['Bairro'] = _.filter(this.filtros.bairro).join(', ')
          }
          if (this.filtros.hasOwnProperty('com_loteamento')) {
            filtrosFormatados['Em Loteamento'] = (this.filtros.com_loteamento ? 'Sim' : 'Não')
          }
          if (this.filtros.hasOwnProperty('loteamento')) {
            filtrosFormatados['Loteamento'] = _.filter(this.filtros.loteamento).join(', ')
          }
          if (this.filtros.hasOwnProperty('lote')) {
            filtrosFormatados['Lote'] = this.filtros.lote
          }
          if (this.filtros.hasOwnProperty('quadra')) {
            filtrosFormatados['Quadra'] = this.filtros.quadra
          }
          if (this.filtros.hasOwnProperty('status')) {
            filtrosFormatados['Status'] = _.filter(this.filtros.status).join(', ')
          }
          if (this.filtros.hasOwnProperty('vago_com_placa')) {
            filtrosFormatados['Vago - Com Placa'] = (this.filtros.vago_com_placa ? 'Sim' : 'Não')
          }
          if (this.filtros.hasOwnProperty('vago_seguranca')) {
            filtrosFormatados['Vago - Segurança'] = _.filter(this.filtros.vago_seguranca).join(', ')
          }
          if (this.filtros.hasOwnProperty('compromissado_condicao')) {
            filtrosFormatados['Compromissado - Condição'] = _.filter(this.filtros.compromissado_condicao).join(', ')
          }
          if (this.filtros.hasOwnProperty('locado_condicao')) {
            filtrosFormatados['Locado - Condição'] = _.filter(this.filtros.locado_condicao).join(', ')
          }
          if (this.filtros.hasOwnProperty('locado_acao_renovatoria')) {
            filtrosFormatados['Locado - Com Ação Renovatória'] = (this.filtros.locado_acao_renovatoria ? 'Sim' : 'Não')
          }
          if (this.filtros.hasOwnProperty('locado_indice')) {
            filtrosFormatados['Locado - Com Placa'] = (this.filtros.locado_indice ? 'Satisfatório' : 'Insatisfatório')
          }
          if (this.filtros.hasOwnProperty('locado_valor_minimo') || this.filtros.hasOwnProperty('locado_valor_maximo')) {
            filtrosFormatados['Locado - Valor'] = _.filter([this.filtros.locado_valor_minimo, this.filtros.locado_valor_maximo]).join(' - ')
          }
          if (this.filtros.hasOwnProperty('invadido_condicao')) {
            filtrosFormatados['Invadido - Condição'] = _.filter(this.filtros.invadido_condicao).join(', ')
          }
          if (this.filtros.hasOwnProperty('area_terreno_minima') || this.filtros.hasOwnProperty('area_terreno_maxima')) {
            filtrosFormatados['Área do Terreno'] = _.filter([this.filtros.area_terreno_minima, this.filtros.area_terreno_maxima]).join(' - ')
          }
          if (this.filtros.hasOwnProperty('area_construida_minima') || this.filtros.hasOwnProperty('area_construida_maxima')) {
            filtrosFormatados['Área Construída'] = _.filter([this.filtros.area_construida_minima, this.filtros.area_construida_maxima]).join(' - ')
          }
          if (this.filtros.hasOwnProperty('area_util_minima') || this.filtros.hasOwnProperty('area_util_maxima')) {
            filtrosFormatados['Área Útil'] = _.filter([this.filtros.area_util_minima, this.filtros.area_util_maxima]).join(' - ')
          }
          if (this.filtros.hasOwnProperty('com_calcada')) {
            filtrosFormatados['Com Calçada'] = (this.filtros.com_calcada ? 'Sim' : 'Não')
          }
          if (this.filtros.hasOwnProperty('com_muro')) {
            filtrosFormatados['Com Muro'] = (this.filtros.com_muro ? 'Sim' : 'Não')
          }
          if (this.filtros.hasOwnProperty('iptu_condicao')) {
            filtrosFormatados['IPTU'] = _.filter(this.filtros.iptu_condicao).join(', ')
          }
          if (this.filtros.hasOwnProperty('estimativa_valor_minimo') || this.filtros.hasOwnProperty('estimativa_valor_maximo')) {
            filtrosFormatados['Estimativa do Valor'] = _.filter([this.filtros.estimativa_valor_minimo, this.filtros.estimativa_valor_maximo]).join(' - ')
          }
          if (this.filtros.hasOwnProperty('vistoria')) {
            filtrosFormatados['Vistoria'] = _.filter(this.filtros.vistoria).join(', ')
          }
          if (this.filtros.hasOwnProperty('tarefas_pendentes')) {
            filtrosFormatados['Com Tarefas Pendentes'] = (this.filtros.tarefas_pendentes ? 'Sim' : 'Não')
          }
        }

        this.loadImoveisDownload().then(() => {
          if (tipo === 'pdf') {
            let doc = new jsPDF()
            let pdfName = `Lista de Imóveis - ${moment().format('DD.MM.YYYY')}`
            let totalPagesExp = '{total_pages_count_string}'
            let pageSize = doc.internal.pageSize
            let pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
            let pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

            const marginTop = 20
            const marginBottom = 25
            const marginLeft = 9
            const marginRight = 9

            const fontSize = 7
            const fontColor = 40

            const currentDate = moment().format('DD/MM/YYYY [às] HH:mm:ss')

            let currentHeight = marginTop

            doc.setFontSize(fontSize)
            doc.setTextColor(fontColor)
            doc.setFont('helvetica', 'normal')

            // Exibe os filtros
            if (Object.keys(filtrosFormatados).length > 0) {
              doc.setFontStyle('bold')
              doc.setFontSize(fontSize * 2)
              const filtrosTitulo = 'Filtros Aplicados'
              doc.text(filtrosTitulo, marginLeft, currentHeight)
              currentHeight += doc.getTextDimensions(filtrosTitulo).h
              currentHeight += 2
              doc.setFontStyle('normal')
              doc.setFontSize(fontSize)
            }
            _.forEach(filtrosFormatados, (filtro, index) => {
              doc.setFontStyle('bold')
              let indexWidth = doc.getTextDimensions(index).w
              doc.text(index + ':', marginLeft, currentHeight)

              doc.setFontStyle('normal')
              let filtrosSplit = doc.splitTextToSize(filtro, pageWidth - indexWidth)
              let filtrosHeight = doc.getTextDimensions(filtro).h
              doc.text(filtrosSplit, indexWidth + marginLeft + 2, currentHeight)

              currentHeight += filtrosHeight
              currentHeight += 2
            })

            let imoveisFormatados = []
            _.forEach(this.imoveisDownload, (imovel) => {
              let apelido = (imovel.apelido ? imovel.apelido : '-')
              let proprietario = (imovel.proprietario ? imovel.proprietario : '-')
              let tipo = (imovel.tipo ? imovel.tipo : '-')
              let cidade = (imovel.endereco ? this.formatarCidade(imovel.endereco.data) : '-')
              let endereco = (imovel.endereco ? this.formatarEndereco(imovel.endereco.data) : '-')
              let status = (imovel.status ? imovel.status.data.status : '-')

              let condicao = '-'
              if (imovel.status) {
                if (imovel.status.data.status === 'Compromissado' && imovel.status.data.compromissado_condicao) {
                  condicao = imovel.status.data.compromissado_condicao
                }
                if (imovel.status.data.status === 'Locado' && imovel.status.data.locado_condicao) {
                  condicao = imovel.status.data.locado_condicao
                }
                if (imovel.status.data.status === 'Invadido' && imovel.status.data.invadido_condicao) {
                  condicao = imovel.status.data.invadido_condicao
                }
              }

              imoveisFormatados.push([
                apelido,
                proprietario,
                tipo,
                cidade,
                endereco,
                status,
                condicao
              ])
            })

            doc.autoTable({
              startY: currentHeight + 2,
              head: [['Apelido', 'Proprietário', 'Tipo', 'Cidade', 'Endereço', 'Status', 'Condição']],
              body: imoveisFormatados,
              margin: {
                top: marginTop,
                bottom: marginBottom,
                left: marginLeft,
                right: marginRight
              },
              styles: {
                valign: 'middle',
                halign: 'center',
                fontSize: fontSize,
                cellPadding: 3,
                minCellWidth: 27
              },
              columnStyles: {
                4: {
                  minCellWidth: 30
                }
              },
              didDrawPage: (data) => {
                // Rodapé
                let str = 'Página ' + doc.internal.getNumberOfPages()
                if (typeof doc.putTotalPages === 'function') {
                    str = str + ' de ' + totalPagesExp
                }

                doc.text(str + ' - Total de imóveis: ' + imoveisFormatados.length, marginLeft, pageHeight - 10)
                doc.text(currentDate, pageWidth - data.settings.margin.right, pageHeight - 10, { align: 'right' })
              }
            })

            if (typeof doc.putTotalPages === 'function') {
              doc.putTotalPages(totalPagesExp)
            }

            doc.save(pdfName + '.pdf')
          }

          if (tipo === 'excel') {
             const header = [[
              'Apelido',
              'Proprietário',
              'Tipo',
              'Cidade',
              'Endereço',
              'Status',
              'Condição',
              'Loteamento',
              'Loteamento (Nome)',
              'Loteamento (Lote)',
              'Loteamento (Quadra)',
              'Registro (Matrícula)',
              'Registro (Transcrição)',
              'Registro (Cartório)',
              'Área do Terreno (m²)',
              'Área Construída (m²)',
              'Área Útil (m²)',
              'Com Calçada',
              'Com Muro',
              'Estimativa do valor (R$)',
              'Data da Estimativa',
              'Valor do m² da região (R$)',
              'IPTU (Número)',
              'IPTU (Situação)',
              'IPTU (Observações)',
              'Registro / Documentos (Observações)'
            ]]
            let imoveisFormatados = []

            _.forEach(this.imoveisDownload, (imovel) => {
              let apelido = (imovel.apelido ? imovel.apelido : '-')
              let proprietario = (imovel.proprietario ? imovel.proprietario : '-')
              let tipo = (imovel.tipo ? imovel.tipo : '-')
              let cidade = (imovel.endereco ? this.formatarCidade(imovel.endereco.data, ' - ') : '-')
              let endereco = (imovel.endereco ? this.formatarEndereco(imovel.endereco.data, ' - ') : '-')
              let status = (imovel.status ? imovel.status.data.status : '-')

              let condicao = '-'
              if (imovel.status) {
                if (imovel.status.data.status === 'Compromissado' && imovel.status.data.compromissado_condicao) {
                  condicao = imovel.status.data.compromissado_condicao
                }
                if (imovel.status.data.status === 'Locado' && imovel.status.data.locado_condicao) {
                  condicao = imovel.status.data.locado_condicao
                }
                if (imovel.status.data.status === 'Invadido' && imovel.status.data.invadido_condicao) {
                  condicao = imovel.status.data.invadido_condicao
                }
              }

              let loteamento = '-'
              let loteamento_nome = '-'
              let loteamento_lote = '-'
              let loteamento_quadra = '-'
              if (imovel.endereco) {
                loteamento = (imovel.endereco.data.loteamento ? 'Sim' : 'Não')
                loteamento_nome = (imovel.endereco.data.loteamento_nome ? imovel.endereco.data.loteamento_nome : '-')
                loteamento_lote = (imovel.endereco.data.loteamento_lote ? imovel.endereco.data.loteamento_lote : '-')
                loteamento_quadra = (imovel.endereco.data.loteamento_quadra ? imovel.endereco.data.loteamento_quadra : '-')
              }

              let registro_matricula = '-'
              let registro_transcricao = '-'
              let registro_cartorio = '-'
              if (imovel.registro) {
                registro_matricula = (imovel.registro.data.matricula ? imovel.registro.data.matricula : '-')
                registro_transcricao = (imovel.registro.data.transcricao ? imovel.registro.data.transcricao : '-')
                registro_cartorio = (imovel.registro.data.cartorio ? imovel.registro.data.cartorio : '-')
              }

              let area_terreno = '-'
              let area_construida = '-'
              let area_util = '-'
              let com_calcada = '-'
              let com_muro = ''
              if (imovel.area) {
                area_terreno = (imovel.area.data.area_terreno ? imovel.area.data.area_terreno : '-')
                area_construida = (imovel.area.data.area_construida ? imovel.area.data.area_construida : '-')
                area_util = (imovel.area.data.area_util ? imovel.area.data.area_util : '-')
                com_calcada = (imovel.area.data.calcada ? 'Sim' : 'Não')
                com_muro = (imovel.area.data.muro ? 'Sim' : 'Não')
              }

              let estimativa_valor = '-'
              let estimativa_data = '-'
              let regiao_valor = '-'
              if (imovel.valor) {
                estimativa_valor = (imovel.valor.data.estimativa_valor ? currencyFormatter.format(imovel.valor.data.estimativa_valor, { code: 'BRL' }) : '-')
                estimativa_data = (imovel.valor.data.estimativa_data ? moment(imovel.valor.data.estimativa_data).format('DD/MM/YYYY') : '-')
                regiao_valor = (imovel.valor.data.regiao_valor ? currencyFormatter.format(imovel.valor.data.regiao_valor, { code: 'BRL' }) : '-')
              }

              let iptu_numero = '-'
              let iptu_situacao = '-'
              let iptu_observacoes = '-'
              const iptu = (imovel.taxas ? _.find(imovel.taxas.data, (o) => {
                return o.taxa === 'IPTU'
              }) : null)
              if (iptu) {
                iptu_numero = iptu.numero
                iptu_situacao = iptu.situacao
                const taxas_observacoes = (imovel.observacoes ? _.find(imovel.observacoes.data, (o) => {
                  return o.tipo === 'taxas'
                }) : null)
                if (taxas_observacoes) {
                  iptu_observacoes = taxas_observacoes.conteudo
                }
              }

              let registro_observacoes = '-'
              const observacoes_tipo_registro = (imovel.observacoes ? _.find(imovel.observacoes.data, (o) => {
                return o.tipo === 'registro'
              }) : null)
              if (observacoes_tipo_registro) {
                registro_observacoes = observacoes_tipo_registro.conteudo
              }

              imoveisFormatados.push([
                apelido,
                proprietario,
                tipo,
                cidade,
                endereco,
                status,
                condicao,
                loteamento,
                loteamento_nome,
                loteamento_lote,
                loteamento_quadra,
                registro_matricula,
                registro_transcricao,
                registro_cartorio,
                area_terreno,
                area_construida,
                area_util,
                com_calcada,
                com_muro,
                estimativa_valor,
                estimativa_data,
                regiao_valor,
                iptu_numero,
                iptu_situacao,
                iptu_observacoes,
                registro_observacoes
              ])
            })

            XlsxPopulate.fromBlankAsync().then(workbook => {
              const sheetName = 'Lista de Imóveis'
              workbook.sheet(0).name(sheetName)

              const initialRow = 2
              let currentRow = initialRow

              if (Object.keys(filtrosFormatados).length > 0) {
                workbook.sheet(sheetName).cell('B' + currentRow).value('Filtros Aplicados')
                workbook.sheet(sheetName).row(currentRow).style({
                  fontFamily: 'Verdana',
                  fontSize: 14,
                  bold: true
                })
                currentRow += 2

                _.forEach(filtrosFormatados, (filtro, index) => {
                  workbook.sheet(sheetName).cell('B' + currentRow).value(index + ': ' + filtro)
                  workbook.sheet(sheetName).cell('B' + currentRow).style({
                    fontFamily: 'Verdana',
                    fontSize: 12
                  })

                  currentRow++
                })

                currentRow += 3

                workbook.sheet(sheetName).cell('B' + currentRow).value('Lista de Imóveis')
                workbook.sheet(sheetName).row(currentRow).style({
                  fontFamily: 'Verdana',
                  fontSize: 14,
                  bold: true
                })
                currentRow += 2
              }

              const headerRow = currentRow
              const contentRow = headerRow + 1
              const tableRange = 'B' + (headerRow) + ':AA' + (headerRow + imoveisFormatados.length)

              workbook.sheet(sheetName).cell('B' + headerRow).value(header)
              workbook.sheet(sheetName).cell('B' + contentRow).value(imoveisFormatados)

              workbook.sheet(sheetName).column('A').width(5)
              workbook.sheet(sheetName).column('B').width(60)
              workbook.sheet(sheetName).column('C').width(40)
              workbook.sheet(sheetName).column('D').width(20)
              workbook.sheet(sheetName).column('E').width(30)
              workbook.sheet(sheetName).column('F').width(60)
              workbook.sheet(sheetName).column('G').width(30)
              workbook.sheet(sheetName).column('H').width(30)
              workbook.sheet(sheetName).column('I').width(30)
              workbook.sheet(sheetName).column('J').width(30)
              workbook.sheet(sheetName).column('K').width(30)
              workbook.sheet(sheetName).column('L').width(30)
              workbook.sheet(sheetName).column('M').width(45)
              workbook.sheet(sheetName).column('N').width(45)
              workbook.sheet(sheetName).column('O').width(45)
              workbook.sheet(sheetName).column('P').width(45)
              workbook.sheet(sheetName).column('Q').width(45)
              workbook.sheet(sheetName).column('R').width(45)
              workbook.sheet(sheetName).column('S').width(30)
              workbook.sheet(sheetName).column('T').width(30)
              workbook.sheet(sheetName).column('U').width(50)
              workbook.sheet(sheetName).column('V').width(30)
              workbook.sheet(sheetName).column('W').width(50)
              workbook.sheet(sheetName).column('X').width(30)
              workbook.sheet(sheetName).column('Y').width(30)
              workbook.sheet(sheetName).column('Z').width(100)
              workbook.sheet(sheetName).column('AA').width(100)

              workbook.sheet(sheetName).range(tableRange).style({
                fontFamily: 'Verdana',
                fontSize: 12,
                horizontalAlignment: 'left',
                verticalAlignment: 'center',
                textDirection: 'left-to-right',
                border: true,
                wrapText: true
              })

              workbook.sheet(sheetName).row(headerRow).style({
                bold: true
              })

              return workbook.outputAsync().then(function (blob) {
                const fileName = `Lista de Imóveis - ${moment().format('DD.MM.YYYY')}.xlsx`
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                  window.navigator.msSaveOrOpenBlob(blob, fileName)
                } else {
                  let url = window.URL.createObjectURL(blob)
                  let a = document.createElement('a')
                  document.body.appendChild(a)
                  a.href = url
                  a.download = fileName
                  a.click()
                  window.URL.revokeObjectURL(url)
                  document.body.removeChild(a)
                }
              });
            })
          }

          this.$store.dispatch('utils/hideLoading')
        }, () => {
          this.$store.dispatch('utils/hideLoading')
        })
        /* eslint-enable */
      },
      changeTab (parametro) {
        const tabId = this.normalizeTabId(parametro)

        if (tabId === this.tabAtiva) {
          return
        }

        this.clearImoveis()
        this.tabAtiva = tabId
        this.loadImoveis()
      },
      openRightNav () {
        this.$store.dispatch('template/setRightNav', true)
      },
      limparFiltros () {
        this.$store.dispatch('imoveis/clearFiltros')
      },
      clearImoveis () {
        this.$store.dispatch('imoveis/clearLista')
      },
      loadImoveis (page) {
        const payload = {}

        if (!_.isEmpty(this.filtros)) {
          Object.assign(payload, this.filtros)
        }

        this.setTabPayloadParams(payload)

        if (page) {
          payload.page = page
        }

        this.$store.dispatch('imoveis/loadLista', payload)
      },
      loadImoveisDownload () {
        const payload = {}

        if (!_.isEmpty(this.filtros)) {
          Object.assign(payload, this.filtros)
        }

        this.setTabPayloadParams(payload)

        return this.$store.dispatch('imoveis/loadListaDownload', payload)
      },
      formatarEndereco (endereco, separador = '\n') {
        const logradouro = _.filter([`${endereco.tipo} ${endereco.logradouro}`, endereco.numero, endereco.complemento]).join(separador)

        return logradouro
      },
      formatarCidade (endereco, separador = '\n') {
        let cidade = '-'
        if (endereco.cidade || endereco.uf) {
          cidade = _.filter([endereco.cidade, endereco.uf]).join(separador)
        }

        return cidade
      }
    }
  }
</script>

<style>
.tabs__items { border: 0; }
@keyframes blink {50% { color: transparent }}
.loader_dot { animation: 1s blink infinite }
.loader_dot:nth-child(2) { animation-delay: 250ms }
.loader_dot:nth-child(3) { animation-delay: 500ms }

@media (max-width: 959px) {
  .imoveis-toolbar {
    height: auto !important;
    min-height: 64px;
    padding-top: 8px;
    padding-bottom: 10px;
    align-items: flex-start;
  }

  .titulo-imoveis {
    width: 100%;
    text-align: left;
    font-size: 24px;
    padding-left: 12px;
  }

  .opcoes_lista_mapa_mobile {
    position: static !important;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    padding-left: 8px;
    margin-top: 2px;
  }

  .opcoes_lista_mapa_mobile .btn {
    margin-left: 0 !important;
    margin-right: 6px !important;
    min-width: 0;
  }

  .opcao-view-btn .btn__content {
    padding: 0 8px !important;
  }

  .tabs__bar {
    overflow-x: auto;
  }
}
</style>



// WEBPACK FOOTER //
// ImoveisLista.vue?80d6044e